// Action types are currently all in same file. When there will be,
// alot more types, then maybe it would be wise to create seperate
// files for each entity (company, terminal etc.).

export const CREATE_ALLOWED_ROUTES = 'CREATE_ALLOWED_ROUTES';

export const LOAD_COMPANIES_REQUEST = 'LOAD_COMPANIES_REQUEST';
export const LOAD_COMPANIES_SUCCESS = 'LOAD_COMPANIES_SUCCESS';
export const LOAD_COMPANIES_FAILURE = 'LOAD_COMPANIES_FAILURE';
export const COMPANIES_NEW_COMPANY = 'COMPANIES_NEW_COMPANY';
export const COMPANIES_EDIT_COMPANY = 'COMPANIES_EDIT_COMPANY';
export const DELETE_COMPANY_REQUEST = "DELETE_COMPANY_REQUEST";
export const COMPANIES_DELETE_COMPANY = "COMPANIES_DELETE_COMPANY";

export const LOAD_TERMINALS_REQUEST = 'LOAD_TERMINALS_REQUEST';
export const LOAD_TERMINALS_SUCCESS = 'LOAD_TERMINALS_SUCCESS';
export const LOAD_TERMINALS_FAILURE = 'LOAD_TERMINALS_FAILURE';
export const ADD_TERMINAL_REQUEST = 'ADD_TERMINAL_REQUEST';
export const TERMINALS_EDIT_TERMINAL = 'TERMINALS_EDIT_TERMINAL';
export const TERMINALS_DELETE_TERMINAL = "TERMINALS_DELETE_TERMINAL";
export const DELETE_TERMINAL_FAILURE = "DELETE_TERMINAL_FAILURE";
export const DELETE_TERMINAL_SUCCESS = "DELETE_TERMINAL_SUCCESS";
export const DELETE_TERMINALS_REQUEST = "DELETE_TERMINALS_REQUEST";
export const DELETE_TERMINAL_FAILURE_CLEAR = "DELETE_TERMINAL_FAILURE_CLEAR";

export const LOAD_PARTS_REQUEST = 'LOAD_PARTS_REQUEST';
export const LOAD_PARTS_SUCCESS = 'LOAD_PARTS_SUCCESS';
export const LOAD_PARTS_FAILURE = 'LOAD_PARTS_FAILURE';
export const ADD_PART_REQUEST = 'ADD_PART_REQUEST';
export const PARTS_EDIT_PART = 'PARTS_EDIT_PART';
export const PARTS_DELETE_PART = "PARTS_DELETE_PART";
export const DELETE_PART_FAILURE = "DELETE_PART_FAILURE";
export const DELETE_PART_SUCCESS = "DELETE_PART_SUCCESS";
export const DELETE_PARTS_REQUEST = "DELETE_PARTS_REQUEST";
export const DELETE_PART_FAILURE_CLEAR = "DELETE_PART_FAILURE_CLEAR";

export const LOAD_USERS_REQUEST = "LOAD_USERS_REQUEST";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAILURE = "LOAD_USERS_FAILURE";
export const DELETE_USERS_REQUEST = "DELETE_USERS_REQUEST";
export const ADD_USER_REQUEST = "ADD_USER_REQUEST";
export const USERS_EDIT_USER = "USERS_EDIT_USER";
export const USERS_DELETE_USER = "USERS_DELETE_USER";

export const LOAD_STATIONPUMPS_REQUEST = 'LOAD_STATIONPUMPS_REQUEST';
export const LOAD_STATIONPUMPS_SUCCESS = 'LOAD_STATIONPUMPS_SUCCESS';
export const LOAD_STATIONPUMPS_FAILURE = 'LOAD_STATIONPUMPS_FAILURE';
export const STATIONS_NEW_STATION = 'STATIONS_NEW_STATION';
export const STATIONS_EDIT_STATION = 'STATIONS_EDIT_STATION';
export const STATIONS_DELETE_STATIONS = "STATIONS_DELETE_STATIONS";

export const MODAL_MODAL_CLOSED = "MODAL_MODAL_CLOSED";

export const SHOW_SNACKBAR_REQUEST = 'SHOW_SNACKBAR_REQUEST';
export const HIDE_SNACKBAR_REQUEST = 'HIDE_SNACKBAR_REQUEST';

export const LOAD_OLDTERMINAL_REQUEST = 'LOAD_OLDTERMINAL_REQUEST';
export const LOAD_OLDTERMINAL_SUCCESS = 'LOAD_OLDTERMINAL_SUCCESS';
export const LOAD_OLDTERMINAL_FAILURE = 'LOAD_OLDTERMINAL_FAILURE';

export const LOAD_NEWTERMINAL_REQUEST = 'LOAD_NEWTERMINAL_REQUEST';
export const LOAD_NEWTERMINAL_SUCCESS = 'LOAD_NEWTERMINAL_SUCCESS';
export const LOAD_NEWTERMINAL_FAILURE = 'LOAD_NEWTERMINAL_FAILURE';

export const LOAD_STATUSES_REQUEST = 'LOAD_STATUSES_REQUEST';

export const ADD_TERMINALS_SEARCH_CRITERIA = 'ADD_TERMINALS_SEARCH_CRITERIA';
export const ADD_PARTS_SEARCH_CRITERIA = 'ADD_PARTS_SEARCH_CRITERIA';
export const ADD_STATIONS_SEARCH_CRITERIA = 'ADD_STATIONS_SEARCH_CRITERIA';
export const ADD_COMPANIES_SEARCH_CRITERIA = 'ADD_COMPANIES_SEARCH_CRITERIA';
export const ADD_USERS_SEARCH_CRITERIA = 'ADD_USERS_SEARCH_CRITERIA';

export const SUBMIT_TERMINALSWITCH_REQUEST = 'SUBMIT_TERMINALSWITCH_REQUEST';
export const SUBMIT_TERMINALSWITCH_SUCCESS = 'SUBMIT_TERMINALSWITCH_SUCCESS';
export const SUBMIT_TERMINALSWITCH_FAILURE = 'SUBMIT_TERMINALSWITCH_FAILURE';

export const GO_NEXT_TERMINALSWITCH_STEP = 'GO_NEXT_TERMINALSWITCH_STEP';
export const GO_BACK_TERMINALSWITCH_STEP = 'GO_BACK_TERMINALSWITCH_STEP';
export const GO_FIRST_TERMINALSWITCH_STEP = 'GO_FIRST_TERMINALSWITCH_STEP';
export const GO_TO_TERMINALSWITCH_STEP = 'GO_TO_TERMINALSWITCH_STEP';
export const RESET_TERMINALSWITCH = 'RESET_TERMINALSWITCH';
export const CHANGE_TERMINALSWITCH_MODE = 'CHANGE_TERMINALSWITCH_MODE';

// more...



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js